import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_file_reader = _resolveComponent("file-reader")!
  const _component_modal = _resolveComponent("modal")!

  return (_openBlock(), _createBlock(_component_modal, {
    class: "large",
    title: `Загрузка фото для ПВЗ (${_ctx.pvzName})`,
    "confirm-button-text": "Загрузить",
    loading: _ctx.state.is_loading,
    onCancel: _ctx.emitCancel,
    onConfirm: _ctx.uploadPhotos
  }, {
    default: _withCtx(() => [
      _createVNode(_component_file_reader, {
        value: _ctx.state.files,
        "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.state.files) = $event)),
        "is-invalid": _ctx.state_form$.files.$error,
        "validation-errors": _ctx.state_form$.files.$errors,
        placeholder: "Выберите изображения"
      }, null, 8, ["value", "is-invalid", "validation-errors"])
    ]),
    _: 1
  }, 8, ["title", "loading", "onCancel", "onConfirm"]))
}